import { render, staticRenderFns } from "./PlaceholderTabContent.vue?vue&type=template&id=353cdeba&scoped=true"
import script from "./PlaceholderTabContent.vue?vue&type=script&lang=js"
export * from "./PlaceholderTabContent.vue?vue&type=script&lang=js"
import style0 from "./PlaceholderTabContent.vue?vue&type=style&index=0&id=353cdeba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353cdeba",
  null
  
)

export default component.exports